const fallbackStoreUrl = 'https://novomins.com.au';

export const storeUrl = typeof window !== 'undefined' && window.location.origin
	? window.location.origin
	: fallbackStoreUrl;
export const apiUrl = `${storeUrl}/api/2024-01/graphql.json`;
export const storefrontAccessToken = '719b3d22cccc2def78a52280659ac8f6';

